import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const FormApiError = (props) => {
  const wrapperRef = useRef();

  useEffect(() => {
    wrapperRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const { children } = props;

  return (
    <FormErrorMessageStyles ref={wrapperRef}>{children}</FormErrorMessageStyles>
  );
};

const FormErrorMessageStyles = styled.p`
  border-radius: 4px;
  background: rgb(219, 48, 63);
  color: var(--white);

  padding: 15px;
  margin-bottom: 20px;
`;

export default FormApiError;
